import { commonUtils } from '../components/common_utils';
import { adListingAutoLoad } from './ad_listing_autoload_sds_ads';
import './search_form';

export const advanceDealer = {
    dealerSiteId: $('#app').data('dealersite-id'),
    largeViewHeaderLinkManage: {
        init() {
            this.largeViewHeaderLinkWidth = $('#largeViewHeader').width();
            this.largeViewHeaderTotalLinks = $('#largeViewHeader li:not(:last)').length;
            this.loop = 1;
            this.maximumWidth = 800;
            this.manageMenu();
        },
        manageMenu() {
            if (this.largeViewHeaderLinkWidth > this.maximumWidth) {
                $('#largeViewHeaderNavigation').show();
            }
            while (this.largeViewHeaderLinkWidth > this.maximumWidth) {
                $('#largeViewHeader li:not(:last)')
                    .eq(this.largeViewHeaderTotalLinks - this.loop)
                    .hide();
                $('#largeViewHeaderNavigation .moreMenuLinks')
                    .eq($('.moreMenuLinks').length - this.loop)
                    .show();
                this.loop += 1;
                this.largeViewHeaderLinkWidth = $('#largeViewHeader').width(); // reset width

                // To avoid go in an infinite loop in case of any JS error, break after total menu links
                if (this.loop > this.largeViewHeaderTotalLinks) {
                    break;
                }
            }
        },
    },
    smallViewHeaderLinkManage: {
        init() {
            this.headerNavigationElement = $('#smallViewHeaderNavigation');
            this.headerLinkWidth = $('#smallViewHeader').width();
            this.headerTotalLinks = $('#smallViewHeader li:not(:last)').length;
            this.loop = 1;
            this.maximumWidth = 300;
            this.manageMenu();
        },
        manageMenu() {
            if (this.headerNavigationElement.length > 0 && this.headerLinkWidth > this.maximumWidth) {
                this.headerNavigationElement.show();
            }

            while (this.headerNavigationElement.length && this.headerLinkWidth > this.maximumWidth) {
                let smallViewLi = $('#smallViewHeader li:not(:last)').eq(this.headerTotalLinks - this.loop);
                let smallViewLink = $(smallViewLi).find('a');
                $(smallViewLi).remove();
                $('.smallViewNavigation').prepend(
                    `<a href="${$(smallViewLink).prop('href')}" class="show-till-940-imp" target="${$(smallViewLink).prop('target')}">${$(smallViewLink).prop('text')}</a>`
                );
                this.loop += 1;
                this.headerLinkWidth = $('#smallViewHeader').width(); // reset width

                // To avoid go in a infinite loop in case of any JS error, break after total menu links
                if (this.loop > this.headerTotalLinks) {
                    break;
                }
            }
        },
    },
    validateFeedbackData() {
        let $name = $('#adsName');
        let $email = $('#adsEmail');
        let $phone = $('#adsPhone');
        let $comment = $('#adsComment');
        let mandatoryFieldMessage = Translations.missing_mandatory;
        if (commonUtils.isEmpty($name.val())) {
            alert(mandatoryFieldMessage);
            $name.focus();
            return false;
        }
        if ($phone.val() && !commonUtils.isValidPhone($phone.val())) {
            alert(Translations.invalid_phone);
            $phone.focus();
            return false;
        }
        if (commonUtils.isEmpty($email.val())) {
            alert(mandatoryFieldMessage);
            $email.focus();
            return false;
        }
        if (!commonUtils.isValidEmail($email.val())) {
            alert(Translations.invalid_email);
            $email.focus();
            return false;
        }
        if (commonUtils.isEmpty($comment.val())) {
            alert(mandatoryFieldMessage);
            $comment.focus();
            return false;
        }

        return true;
    },
};

$(function () {
    let $body = $('body');
    let $dealerSearchForm = $('#dealerSearchForm');
    // Listing page: Initialize pagination auto loading
    adListingAutoLoad.init({
        formElementId: 'dealerSearchForm',
        elementToListData: 'listMoreData',
        requestUrl: $dealerSearchForm.prop('action'),
    });

    // Listing page: show/hide more content link
    $body.on('click', '.showMoreLine', function () {
        $(this).parent().prev().css({ height: 'auto', overflow: 'visible' });
        $(this).hide();
    });

    // Listing page: sorting option
    $('#dealerSearchSorting').change(function () {
        let sortValue = $(this).val().split('_');
        $dealerSearchForm.find('#sortCol').val(sortValue[0]);
        $dealerSearchForm.find('#ord').val(sortValue[1]);
        $dealerSearchForm.submit();
    });

    // Share twitter url
    $body.on('click', '.shareTwitterUrl', function () {
        commonUtils.openNewWindow($(this).data('twitter-share-url'), 660, 430, '', 250, 200);
        commonUtils.dataLayer.shareButtonDataLayerEvent('Twitter');
    });

    // Display map for contact us page
    let $loadGoogleMap = $('.loadGoogleMap');
    if ($loadGoogleMap.length && window.$('#cmp_consent').data('google-map')) {
        commonUtils.loadEmbedMap($loadGoogleMap.data('map-address'), $loadGoogleMap.data('map-canvas-name'));
    }

    // Send feedback
    $('#advanceDealerFeedbackForm').submit(function () {
        return advanceDealer.validateFeedbackData();
    });

    $('.deliveryTooltipAds, .warrantyTooltipAds').click(function () {
        const elementData = $(this).data();
        const $currentTooltip = $(`#${elementData.tooltipName}TooltipId_${elementData.id}`);
        // Hide all tooltips other than the current one
        $('.badge-with-info__tooltip').not($currentTooltip).hide();
        // Toggle the current tooltip visibility
        $currentTooltip.toggle();
    });

    $('.vinInfoIcon').click(function () {
        $(this).next('.vinInfoIconToolTip').toggle(); // Toggle the next sibling (tooltip)
    });
});

// Manage header links with small/large layouts
advanceDealer.smallViewHeaderLinkManage.init();
advanceDealer.largeViewHeaderLinkManage.init();
